import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

export interface CustomFieldTabDocument extends BaseDocument {
  name: string
  icon: string
  renderMode: 'tab' | 'inline'
  isSystem: boolean
  sortOrder: string | null
  workItemTypeIds: Array<string>
  projectIds: Array<string>
}

const hooks = createEntityHooks<CustomFieldTabDocument>('customfieldtabs')

export const useCustomFieldTabs = (filter?: Partial<CustomFieldTabDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { customFieldTabs: data, isLoading, db }
}

export const useCustomFieldTab = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { customFieldTab: data, isLoading }
}

export const useCustomFieldTabMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createCustomFieldTab: create,
    updateCustomFieldTab: update,
    deleteCustomFieldTab: deleteEntity,
  }
}
